import gql from 'graphql-tag';

export const getScheduledVisitsByHostUserId = gql(`
  query getScheduledVisitsByHostUserId(
    $startDate: DateTime
    $endDate: DateTime
  ) {
    scheduledVisitsByHostUserId(startDate: $startDate, endDate: $endDate) {
      result {
        visits {
          id
          visitor {
            firstName
            lastName
            company
            email
          }
          accessGrantBuildingId
          hostName
          tenantName
          floor
          companyName
          status
          visitorNote
          staffNote
          startDatetime
          endDatetime
          submittedBy
          eventName
          createdAtDatetime
          sourceId
          submissionId
          submissionVisitorId
          recurrenceId
          validStateTransitions
          visitorWatchlistMatchInfo {
            watchlistSeverityLevel
            watchlistId
            isApprovalRequired
            isWatchlistDisplayed
            displayText
          }
          inviteName
        }
        eventNames
        tenantNames
      }
      totalCount
    }
  }
`);
